<div class="engie-header-left">
  <a class="head-logo" href="#"><img src="./assets/img/Logo_w.svg" alt="Engie" /></a>
  <span class="head-title">Portal de Gestión de Terceros</span>
</div>

<div class="engie-header-right" *ngIf="isAuthenticated">
  <div class="engie-user-icon"><img src="./assets/img/user-filled.svg" /></div>
  <div class="engie-user-data">
    <div>
      <h4>Hola {{user.nombres}} {{user.apellidos}}</h4>
    </div>
    <div><a [routerLink]="" (click)="logout()">Cerrar sesión</a></div>
  </div>
</div>

<div class="engie-header-company" *ngIf="isAuthenticated">
  <div class="engie-user-icon"><img src="./assets/img/icon-company.png" /></div>
  <div class="engie-user-data">
    <div class="engie-select-company">Compañía:
      <button *ngIf="user.companias.length > 1" mat-button [matMenuTriggerFor]="menu">{{ user.companiaDefault.nombre
        }}</button>
      <button *ngIf="user.companias.length == 1" mat-button>{{ user.companiaDefault.nombre }}</button>

      <mat-menu #menu="matMenu">
        <ng-container *ngFor="let item of user.companias">
          <button mat-menu-item (click)="changecompany(item)">{{ item.nombre }}</button>
        </ng-container>
      </mat-menu>
    </div>
  </div>
  <div class="engie-user-data">
    <button mat-button *ngIf="!user.companiaDefault.isDefault && user.companias.length>1"
      (click)="setDefault(user.companiaDefault)" class="btn-header-change">Establecer por defecto</button>
  </div>
</div>